import { render } from "./ServiceAppeal.vue?vue&type=template&id=9c9269c0&scoped=true&ts=true"
import script from "./ServiceAppeal.vue?vue&type=script&lang=ts"
export * from "./ServiceAppeal.vue?vue&type=script&lang=ts"

import "./ServiceAppeal.vue?vue&type=style&index=0&id=9c9269c0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9269c0"]])

export default __exports__